<template>
  <transition name="interactive-social-wall-modal">
    <div v-if="visible"
         class="interactive-social-wall__modal-overlay"
         tabindex="-1"
         @click.self="$emit('close')"
         @keydown.esc.stop="$emit('close')"
    >
      <div :aria-label="ariaLabel"
           :class="`interactive-social-wall__modal--${size}`"
           aria-modal="true"
           class="interactive-social-wall__modal"
           role="dialog"
      >
        <header class="interactive-social-wall__modal-header">
          <slot name="title"/>
          <button :aria-label="closeLabel"
                  :disabled="busy"
                  class="interactive-social-wall__modal-close"
                  type="button"
                  @click="$emit('close')"
          >
            <i aria-hidden="true" class="uil-times"/>
          </button>
        </header>

        <slot/>
      </div>
    </div>
  </transition>
</template>

<script>
const MODAL_SIZES = ["default", "wide", "compact"];

export default {
  name: "SocialWallModalShell",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: "default",
      validator: (value) => MODAL_SIZES.includes(value),
    },
    ariaLabel: {
      type: String,
      required: true,
    },
    closeLabel: {
      type: String,
      required: true,
    },
    busy: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped>
.interactive-social-wall__modal-overlay,
.interactive-social-wall__modal-overlay * {
  box-sizing: border-box;
}

.interactive-social-wall__modal-overlay button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin: 0;
  padding: 0;
  color: inherit;
  font: inherit;
  line-height: 1;
  cursor: pointer;
  background: transparent;
  border: 0;
  outline: none;
  box-shadow: none;
}

.interactive-social-wall__modal-overlay {
  position: fixed;
  z-index: 2050;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  background: rgba(17, 24, 39, 0.54);
  backdrop-filter: blur(2px);
}

.interactive-social-wall__modal {
  display: flex;
  width: min(620px, 100%);
  max-height: calc(100vh - 40px);
  max-height: calc(100dvh - 40px);
  flex-direction: column;
  overflow: hidden;
  background: #ffffff;
  border: 1px solid #e0e5ec;
  border-radius: 12px;
  box-shadow: 0 24px 70px rgba(15, 23, 42, 0.24);
}

.interactive-social-wall__modal--wide {
  width: min(980px, 100%);
}

.interactive-social-wall__modal--compact {
  width: min(460px, 100%);
}

.interactive-social-wall__modal-header {
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  justify-content: space-between;
  min-height: 58px;
  padding: 14px 18px;
  border-bottom: 1px solid #e8ebf0;
}

.interactive-social-wall__modal-close {
  flex: 0 0 auto;
  width: 34px;
  height: 34px;
  color: var(--iconColor) !important;
  background: #f5f7f9 !important;
  border-radius: 50%;
}

.interactive-social-wall__modal-close i {
  font-size: 19px;
}

.interactive-social-wall__modal-close:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

.interactive-social-wall-modal-enter-active,
.interactive-social-wall-modal-leave-active {
  transition: opacity 180ms ease;
}

.interactive-social-wall-modal-enter-active .interactive-social-wall__modal,
.interactive-social-wall-modal-leave-active .interactive-social-wall__modal {
  transition: transform 180ms ease, opacity 180ms ease;
}

.interactive-social-wall-modal-enter,
.interactive-social-wall-modal-leave-to {
  opacity: 0;
}

.interactive-social-wall-modal-enter .interactive-social-wall__modal,
.interactive-social-wall-modal-leave-to .interactive-social-wall__modal {
  opacity: 0;
  transform: translateY(8px) scale(0.985);
}

@media (max-width: 760px) {
  .interactive-social-wall__modal--wide {
    width: min(620px, 100%);
  }
}

@media (max-width: 640px) {
  .interactive-social-wall__modal-overlay {
    align-items: stretch;
    padding: 0;
  }

  .interactive-social-wall__modal {
    width: 100%;
    height: 100vh;
    height: 100dvh;
    max-height: 100vh;
    max-height: 100dvh;
    border-radius: 0;
  }

  .interactive-social-wall__modal-header {
    min-height: 60px;
  }
}

@media (max-width: 480px) {
  .interactive-social-wall__modal-header {
    padding-right: 14px;
    padding-left: 14px;
  }
}
</style>
